import { Box, HStack, VStack } from "@chakra-ui/react";
import React, { useState } from "react";
import APButton from "../../../components/APButton";
import WordSelect from "../../../components/WordSelect";
import WordChip from "./WordChip";
import { VocabWord } from "../../../VocabModel";
import { IExerciserSDK } from "ap-exerciser-sdk";
import { useVocabIntl } from "../../../hooks/useVocabTranslation";

interface WordsSelectionProps {
  sdk: IExerciserSDK | undefined;
  onSelectWords: (words: VocabWord[], scenarioId?: string) => void;
  saving: boolean
  scenarioWords: VocabWord[];
  mappedWordList: Map<string, VocabWord[]>;
}

export default function WordsSelection({
                                         sdk,
                                         onSelectWords,
                                         saving,
                                         scenarioWords,
                                         mappedWordList,
                                       }: WordsSelectionProps) {
  const { getFormattedString, APFormattedMessage } = useVocabIntl();
  const [edited, setEdited] = useState(false);
  const [selectedWords, setSelectedWords] = useState<VocabWord[]>(() => {
    return scenarioWords?.slice();
  });

  const handleSave = () => {
    onSelectWords(selectedWords);
  };

  const addWord = (word: VocabWord) => {
    setSelectedWords([...selectedWords, word]);
  }

  const removeWord = (word: VocabWord) => {
    const index = selectedWords.findIndex(selectedWord => selectedWord.id === word.id)
    if (index >= 0) {
      selectedWords.splice(index, 1)
      setSelectedWords([...selectedWords]);
    }
  }


  return (
    <VStack borderRadius={"2xl"} gap={1} padding={4} width={"100%"}
            height={"100%"} maxHeight={"100%"} alignItems={"stretch"}
            bgImage={"var(--ap-theme-scenario-edit)"} bgRepeat={"no-repeat"} bgPos={"right bottom"}>
      <WordSelect
        key={"word-select"}
        selectedWords={selectedWords}
        mappedWordList={mappedWordList}
        addWord={addWord}
        sdk={sdk}
      />
      <HStack mt={2} flexWrap={"wrap"} flexGrow={1} gap={2} alignItems={"start"} alignContent={"start"}
              overflowY={"auto"}>
        {selectedWords.map((selectedWord) => (
          <WordChip
            key={selectedWord.id}
            word={selectedWord}
            formattedWord={selectedWord.label}
            onClose={removeWord}
          />
        ))}
      </HStack>
      <Box mt="auto" pt="3rem">
        <APButton
          onClick={handleSave}
          colorScheme="primary"
          sx={{ height: "3.5rem" }}
          isLoading={saving}
          aria-label={getFormattedString('aria-label-save-button')}
        >
          <APFormattedMessage id={"save-exercise-button"} />
        </APButton>
      </Box>
    </VStack>
  );
}
